import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../utils/api-handler.util'

export const useCountries = () => {
  return useQuery({
    queryKey: ['countries'],
    queryFn: () => handleGetRequest('/countries'),
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 1 hour
  })
}

export default useCountries
